module.exports = __webpack_public_path__ + "6bb6d33ff7152d2751395144cf91f50c.svg";